/**
 * Le foto segnaposto dell'anteprima di /editoriali.
 *
 * Vengono dal riferimento grafico (uploads/Consegna_Editoriali_revisionati_OI.zip)
 * e stanno in public/anteprima/editoriali/. Servono solo a giudicare
 * l'impaginazione: il riferimento le dichiara «immagini di esempio» e dice
 * che la selezione fotografica definitiva si farà dopo, quindi **non** sono
 * l'abbinamento approvato fra foto e pezzo.
 *
 * Le legge solo `schedaDemo` (lib/editoriali-raccolta.ts), cioè il ramo dei
 * provvisori: nel ramo a monte la foto è `image_url` del dispaccio e questa
 * tabella non conta. Ogni foto porta la didascalia «Immagine di esempio»,
 * stampata sopra la foto, così non si legge come una scelta della redazione.
 *
 * Per sostituirle: cambiare qui `src` (o cancellare la voce, e il riquadro
 * torna alla copertina tipografica di components/editoriali/FotoEditoriale.tsx).
 * Il giorno in cui i contenuti sono veri si cancellano questo file e la
 * cartella public/anteprima/editoriali/.
 *
 * Le foto sono ritagli larghi (rapporto 2,4-2,8, 520-760 pixel): dentro il
 * riquadro 3:2 delle schede `object-cover` ne mostra la parte centrale.
 * demo-01 e demo-06 non sono qui perché hanno già una foto vera del CDN, in
 * 3:2, ed è il caso che il riquadro deve mostrare intero.
 */

const DIR = "/anteprima/editoriali";
const ESEMPIO = "Immagine di esempio";

export const FOTO_ESEMPIO: Record<string, { src: string; didascalia: string }> = {
  frattura: { src: `${DIR}/editoriale-industria.jpg`, didascalia: `${ESEMPIO} · Industria e filiere` },
  "demo-02": { src: `${DIR}/editoriale-archivio-2.jpg`, didascalia: ESEMPIO },
  "demo-03": { src: `${DIR}/editoriale-archivio-3.jpg`, didascalia: ESEMPIO },
  "demo-04": { src: `${DIR}/editoriale-archivio-4.jpg`, didascalia: ESEMPIO },
  "demo-05": { src: `${DIR}/editoriale-industria.jpg`, didascalia: ESEMPIO },
  "demo-07": { src: `${DIR}/editoriale-archivio-1.jpg`, didascalia: ESEMPIO },
  "demo-08": { src: `${DIR}/editoriale-archivio-2.jpg`, didascalia: ESEMPIO },
  "demo-09": { src: `${DIR}/editoriale-archivio-3.jpg`, didascalia: ESEMPIO },
  "demo-10": { src: `${DIR}/editoriale-archivio-4.jpg`, didascalia: ESEMPIO },
};
